import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams, useLocation } from 'react-router-dom';
import Navbar from '../../components/layout/Navbar/Navbar';
import Sidebar from '../../components/layout/Sidebar/Sidebar';
import BemVindoComponent from '../../components/Dashboard-Cadastro-Inst/BemVindoComponent';
import CampusForm from '../../components/Dashboard-Cadastro-Inst/CampusForm';
import { getCargoIdSidebar } from '../../constants/sidebarConfig';
import apiService from '../../services/api';
import styled from "styled-components";

const NAVBAR_HEIGHT = 65;
const SIDEBAR_WIDTH = 300;

const PageWrapper = styled.div`
  display: flex;
  flex-direction: column;
  height: 100vh;
  background: #ffffff;
`;

const ContentWrapper = styled.div`
  display: flex;
  flex: 1;
  margin-top: 60px;
`;

const MainContent = styled.main`
  flex: 1;
  margin-left: ${SIDEBAR_WIDTH}px; /* libera espaço para o sidebar fixo */
  overflow-y: auto;
  height: calc(100vh - ${NAVBAR_HEIGHT}px); /* limita para scroll interno */
`;

const CadastroCampis = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [searchParams] = useSearchParams();
  const [editData, setEditData] = useState(null);
  const [sidebarItems, setSidebarItems] = useState([]);

  useEffect(() => {
    const fetchUser = async () => {
      try {
        const userData = await apiService.getCurrentUser();
        const filteredItems = getCargoIdSidebar(userData.cargoId);
        setSidebarItems(filteredItems);
      } catch (err) {
        console.error('Erro ao buscar usuário:', err);
      }
    };

    fetchUser();
  }, []);

  useEffect(() => {
    const mode = searchParams.get('mode');
    
    if (mode === 'edit') {
      let campusData = null;
      
      if (location.state?.editData) {
        campusData = location.state.editData;
      }
      else {
        const storedData = sessionStorage.getItem('campusEditData');
        if (storedData) {
          try {
            campusData = JSON.parse(storedData);
          } catch (e) {
            console.error('Erro ao parsear dados de edição:', e);
          }
        }
      }
      
      if (campusData) {
        setEditData(campusData);
      } else {
        navigate('/CadastroCampis');
      }
    }
  }, [searchParams, location.state, navigate]);

  const handleVoltar = () => {
    navigate(location.state?.returnPath || '/Campis');
  };

  return (
    <PageWrapper>
      <Navbar 
        onLogout={apiService.logout}
        showHome={true}
        showNotifications={true}
        showProfile={true}
        showLogout={true}
      />
      <ContentWrapper>
        <Sidebar items={sidebarItems} />
        <MainContent>
          <BemVindoComponent />
          <CampusForm 
            editData={editData}
            onVoltar={handleVoltar}
          />
        </MainContent>
      </ContentWrapper>
    </PageWrapper>
  );
};

export default CadastroCampis;
